<template>
  <v-card :loading="currentLeadLoading||currentLeadProductsLoading">
    <template v-if="currentLeadLoading||currentLeadProductsLoading">
      <v-card-title>Product</v-card-title>
    </template>
    <template v-else>
      <v-card-title>
        Product
        <v-spacer></v-spacer>
        <v-btn class="mt-0" color="secondary" x-small @click="goToProduct(currentLeadProducts.id)"><v-icon small>{{openProductIcon}}</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <p class="mb-1 text-caption">Product Type</p>
            <p class="display-1 accent--text">{{currentLeadProducts.product_kind | kind}}</p>
          </v-col>
          <v-col>
            <p class="mb-1 text-caption">Product ID</p>
            <p class="display-1 accent--text">{{currentLeadProducts.id}}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p class="mb-1 text-caption">Status</p>
            <p><b>{{currentLeadProducts.status}}</b></p>
          </v-col>
          <v-col>
            <p class="mb-1 text-caption">Tariff</p>
            <p><b>{{tariff.name | notEmpty}}</b></p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <p class="mb-1 text-caption">Monthly Total</p>
            <p><b>{{currentLeadProducts.monthly_total | formatTotal}}</b></p>
          </v-col>
          <v-col>
            <p class="mb-1 text-caption">Upfront Total</p>
            <p><b>{{currentLeadProducts.upfront_total | formatTotal}}</b></p>
          </v-col>
          <v-col>
            <p class="mb-1 text-caption">Sold Date</p>
            <p><b>{{currentLeadProducts.sold_date | notEmpty}}</b></p>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
  import { mapState,mapGetters } from "vuex";
  import moment from 'moment';
  import { mdiOpenInNew } from '@mdi/js';
  export default {
    data(){return{openProductIcon:mdiOpenInNew}},
    props: ['product'],
    computed: {
      ...mapState('leads', ['currentLeadProducts','currentLeadProductsLoading','currentLeadLoading']),
      ...mapGetters('leads', ['getproductByID','getTariffByID']),
      tariff(){
        if(this.currentLeadProducts!==undefined){
          return this.getTariffByID(this.currentLeadProducts.tariff_id);
        }
        return {name:''};
      },
    },
    filters: {
      kind: function(val) {
        let kindMap = {web:'Website',voip:'VoIP',voipseat:'VoIP Seat',telco:'Telco'};
        return (val===null||val===undefined||val==='')?'-':kindMap[val.toLowerCase()];
      },
      notEmpty: function(val) {
        return (val === null || val === "" || val === undefined)?'-':val;
      },
      formatTotal: function(val) {
        return (val === null || val === "" || val === undefined)?'-':`£${val.toFixed(2)}`;
      },
      endDate(prod){
        if(prod.confirmed_date!==null&&prod.confirmed_date!==undefined&&prod.confirmed_date!==''){
          return moment(prod.confirmed_date).add(`${prod.contract_length_months} Months`).format('YYYY-MM-DD');
        }else{ return '-'; }
      },
    },
    methods: {
      goToProduct(id) {
        this.$router.push(`/products/${id}/`);
      }
    },
  }
</script>

<style lang="scss" scoped></style>
